import {
    isSupportVisPopup,
    PopupChildManager,
    PopupParentManager,
} from 'widgets/supportVisualisation/SupportVisualisationPopup/popup';
import { buildLogger, LoggingService } from '@instinet-analytics/core-lib';
import { NotificationService } from 'notification/NotificationService';
import { Store } from 'redux';
import { useServices } from 'app/hooks';
import ContactSupportService from 'app/contactSupport/ContactSupportService';

interface SupportVisualisationPopupServiceOptions {
    contactSupportService: ContactSupportService;
    loggingService: LoggingService;
    notificationService: NotificationService;
}
export class SupportVisualisationPopupService {
    public readonly popupParent?: PopupParentManager;
    public readonly popupChild?: PopupChildManager;

    public constructor(options: SupportVisualisationPopupServiceOptions) {
        const logger = buildLogger(
            'SupportVisualisationPopupService',
            options.loggingService
        );
        const notify = options.notificationService.showInfo;
        const isPopup = isSupportVisPopup();
        if (isPopup) {
            this.popupChild = new PopupChildManager({
                notify,
                logger,
            });
        } else {
            this.popupParent = new PopupParentManager({
                logger,
                contactSupportService: options.contactSupportService,
            });
        }
    }

    public setStore(store: Store) {
        if (this.popupParent) {
            this.popupParent.store = store;
        }
    }
}

export const useSupportVisualisationPopupService = () =>
    useServices().supportVisualisationPopup;

export const useSupportVisualisationPopupChild = () =>
    useSupportVisualisationPopupService().popupChild;

export const useSupportVisualisationPopupParent = () =>
    useSupportVisualisationPopupService().popupParent;
